<div class="domain-confirm-wrapper">
  <h2 class="domain-confirm-title">Supplier with this domain already exists</h2>

  <div mat-dialog-content class="domain-confirm-content">
    <p>
      A supplier already exists for the domain
      <strong>{{ data.domain }}</strong>.
    </p>

    <ng-container *ngIf="data.existingSuppliers.length === 1">
      <p class="domain-confirm-supplier-line">
        <strong>{{ data.existingSuppliers[0].companyName }}</strong>
        <span> &mdash; {{ data.existingSuppliers[0].emailAddress }}</span>
      </p>
    </ng-container>

    <ng-container *ngIf="data.existingSuppliers.length > 1">
      <p>Select the supplier to update:</p>
      <mat-radio-group
        class="domain-confirm-radio-group"
        [(ngModel)]="selectedSupplierId">
        <mat-radio-button
          *ngFor="let s of data.existingSuppliers"
          class="domain-confirm-radio-button"
          [value]="s.supplierId">
          {{ s.companyName }} ({{ s.emailAddress }})
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>

    <p class="domain-confirm-question">
      Do you want to add
      <strong>{{ data.typedEmail }}</strong>
      as an additional contact email to this existing supplier?
    </p>
  </div>

  <div mat-dialog-actions class="domain-confirm-actions">
    <button mat-stroked-button (click)="onCancel()">No, cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="selectedSupplierId == null"
      (click)="onConfirm()">
      Yes, add email
    </button>
  </div>
</div>
